import React from 'react';
import { Link } from 'react-router-dom';
import mantisWhiteLogo from '../Assets/img/mantisWhiteLogo2.png';
import './styles/publicPages.scss';

const PublicFooter = () => {
  return (
    <footer className="public-footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="logo-container">
              <img src={mantisWhiteLogo} alt="Mantis Logo" className="footer-logo" />
            </div>
            <p className="company-description">
              Plataforma tecnológica con agente de inteligencia artificial para la gestión 
              empresarial, control presupuestal y automatización de procesos de compras.
            </p>
          </div>
          
          <div className="footer-section">
            <h3>Enlaces Importantes</h3>
            <ul className="footer-links">
              <li>
                <Link to="/data-treatment-policies">
                  Políticas de Tratamiento de Datos
                </Link>
              </li>
              <li>
                <Link to="/terms-and-conditions">
                  Términos y Condiciones
                </Link>
              </li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h3>Contacto</h3>
            <ul className="footer-links">
              <li>
                <a href="mailto:andres@mantisapp.co">
                  andres@mantisapp.co
                </a>
              </li>
              <li>
                <a href="tel:+573154308744">
                  +57 315 430 8744
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Mantis. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter;
